import axios from 'axios'
import qs from 'qs'
import { Message } from 'element-ui'
import router from '../router/index'
import store from '../store/index'

// axios全局配置
axios.defaults.timeout = 30000
axios.defaults.baseURL = '/plat/sstk-plat/'
// axios.defaults.baseURL = 'http://10.197.237.98:8082/sstk-plat/'
axios.defaults.withCredentials = true

let isToken = true;
let isShowError = true;

// axios拦截器
// 请求拦截器
axios.interceptors.request.use(config => {
    if (config.method === 'post') {
        if (config.isRaw) {
            config.headers['Content-Type'] = "application/json"
            config.data = JSON.stringify(config.data)
        } else {
            config.data = qs.stringify(config.data)
        }
    }

    return config
}, error => {
    return Promise.reject(error)
})

// 响应拦截器
axios.interceptors.response.use(response => {
    if (response.status == 200) {
        if (response.data.code == 200) {
            isToken = true;
            return Promise.resolve(response.data)
        } else {
            if (response.data.code == 401) {
                store.dispatch("setUser", null);
                if (router.currentRoute.path != '/login') {
                    router.push({
                        path: '/login'
                    })
                }
                if (isToken) {
                    Message({
                        message: response.data.msg,
                        type: 'error'
                    })
                    isToken = false
                }
            } else {
                Message({
                    message: response.data.msg,
                    type: 'error'
                })
            }

            return Promise.reject(response)
        }
    } else {
        if (isShowError) {
            Message({
                message: '服务器异常',
                type: 'error'
            })
            isShowError = false;

            setTimeout(() => {
                isShowError = true;
            }, 3000);
        }
        return Promise.reject(response)
    }
}, error => {
    if (isShowError) {
        Message({
            message: '网络异常',
            type: 'error'
        })
        isShowError = false;

        setTimeout(() => {
            isShowError = true;
        }, 3000);
    }
    return Promise.reject(error)
})

export default axios


// WEBPACK FOOTER //
// ./src/api/https.js